<template>
  <div class="position-list page-box">
    <query-header
      ref="header"
      :label-title="$t('Opening_time')"
      @toQuery="toQuery"
      :cent-accont-config="centAccontConfig"
    ></query-header>
    <div class="page-content">
      <div class="content-header">
        <el-input
          class="search-input header-item"
          v-model="login"
          :placeholder="$t('transaction_account')"
          clearable
        ></el-input>
        <el-input
          class="search-input symbol search-input header-item"
          v-model="symbol"
          :placeholder="$t('Trading_symbol')"
          clearable
        ></el-input>
        <vs-button
          class="search-btn header-item"
          @click="searchHandle"
        >{{$t('search')}}</vs-button>
      </div>
      <div class="vs-table-outer">
        <vs-table :noDataText="$t('root.noData')" :data="listData">
          <template
            slot="thead">
            <vs-th>
              {{$t('User.reportOrderId')}}
            </vs-th>
            <vs-th>
              {{$t('transaction_account')}}
            </vs-th>
            <vs-th>
              {{$t('User.reportCmd')}}
            </vs-th>
            <vs-th>
              {{$t('Trading_symbol')}}
            </vs-th>
            <vs-th>
              {{$t('Lot')}}
            </vs-th>
            <vs-th>
              {{$t('Opening_time')}}
            </vs-th>
            <vs-th>
              {{$t('Opening_price')}}
            </vs-th>
            <vs-th
            >
              {{$t('User.reportCurrentPrice')}}
            </vs-th>
            <!--          <vs-th
                        v-if="tabName == 'traderHistory'"
                      >
                        {{'平仓时间'}}
                      </vs-th>
                      <vs-th
                        v-if="tabName == 'traderHistory'"
                      >
                        {{'平仓价格'}}
                      </vs-th>-->
            <vs-th>
              {{$t('Stop_loss_price')}}
            </vs-th>
            <vs-th>
              {{$t('Take_profit_price')}}
            </vs-th>
            <vs-th
            >
              {{$t('Trade.poundage')}}
            </vs-th>
            <vs-th
            >
              {{$t('Inventory_fee')}}
            </vs-th>
            <vs-th>
              {{$t('Trading_profit_and_loss')}}
            </vs-th>
          </template>
          <template slot-scope="{data}">
            <vs-tr :key="index" v-for="(tr, index) in data">
              <vs-td>
                {{tr.order}}
              </vs-td>

              <vs-td>
                {{tr.login}}
              </vs-td>

              <vs-td>
                <!--              类型,买入和卖出-->
                {{tr.cmd  % 2 == 0 ? phFileter('User.buy') : phFileter('User.sell')}}
              </vs-td>
              <vs-td>
                {{tr.symbol}}
              </vs-td>

              <vs-td>
                {{tr.volume}}
              </vs-td>
              <vs-td>
                {{getPositonOrPendingTime(tr)}}
              </vs-td>
              <vs-td>
                {{getPositonOrPendingPrice(tr)}}
              </vs-td>
              <vs-td
              >
                {{tr.closePrice}}
              </vs-td>
              <!--            <vs-th
                            v-if="tabName == 'traderHistory'"
                          >
                            {{tr.closeTime}}
                          </vs-th>
                          <vs-th
                            v-if="tabName == 'traderHistory'"
                          >
                            {{tr.closePrice}}
                          </vs-th>-->
              <vs-td>
                {{tr.sl || '-'}}
              </vs-td>
              <vs-td>
                {{tr.tp || '-' }}
              </vs-td>
              <vs-td
              >
                {{tr.commission}}
              </vs-td>
              <vs-td
              >
                {{tr.storage}}
              </vs-td>
              <vs-td
              >
              <span
                class="profit"
                :class="{on: getActive(tr)}"
              >{{tr.profit}}</span>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
      <div class="pagination-outer" v-if="total">
        <div class="paginnation-left">
          <size-change @sizeChange="sizeChange"></size-change>
          <span class="tatol-count">{{$t('total')}} {{total}} {{$t('item')}}</span>
        </div>
        <vs-pagination
          class="pagination-box"
          :max="max"
          :total="pageSize"
          v-model="page"
        ></vs-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { parseTime } from '@/utils/index';

// 表格字段需要重新调
import initData from "@/mixins/initData";
import queryHeader from "@/components/traderReport/queryHeader";
import {getMt4Group} from "@/api/userCenter";
export default {
  name: "index",
  components: {
    queryHeader,
  },
  props: {
    loginType: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      login: '',
      symbol: '',
      centAccontConfig: false,
    }
  },
  mixins: [initData],
  computed: {
    ...mapGetters(['userInfo']),
  },
  mounted(){
    this.getMt4Group();
    this.init();
  },
  methods: {
    getMt4Group() {
      getMt4Group({
        isMock: 2
      }).then((res) => {

        this.centAccontConfig = res.data.some((item) => {
          return item.groupName == 'Cent';
        });
      });
    },
    beforeInit(){
      this.url = '/crm/reception/partner/opening';
      this.params = {
        sort: 'openTime,desc',
        page: this.page - 1,
        size: this.size,
        custId: this.userInfo.id,
        loginType: this.loginType
      }
      // 添加时间
      let header = this.$refs.header;
      this.params.currency = header.tabsType;
      if(header.date && header.date.length){
        this.params.startTime = header.date[0];
        this.params.endTime = header.date[1];
      }
      if(this.login){
        this.params.login = this.login;
      }
      if(this.symbol){
        this.params.symbol = this.symbol;
      }
      return true;
    },
    phFileter(data){
      return this.$t(data);
    },
    // 开仓时间或者挂单时间
    getPositonOrPendingTime(tr){
      return parseTime(tr.openTime);
    },
    // 开仓价格或者挂单价格
    getPositonOrPendingPrice(tr){
      return tr.openPrice;
    },
    getType(item){
      return item.cmd  % 2 == 0 ? this.$t('User.buy') : this.$t('User.sell');
    },
    getActive(row) {
      if ((row.profit + '').indexOf('-') > -1) {
        return true;
      } else {
        return false;
      }
    },
    searchHandle(){
      this.page = 1;
      this.init();
    }
  },
}
</script>

<style lang="scss" scoped>
.position-list {

}
.search-input {

  &.symbol {

  }
}
</style>
